export const WHITE = '#FFF';
export const BLACK = '#000';
export const BRAND_BLUE = '#0000FF';
export const LIGHT_MODE_BOARDER = '#1E2025';
export const DARK_MODE_BOARDER = '#282B31';
// Button hover and active colors
export const BUTTON_HOVER_LIGHT_SOLID = '#2A2A2A';
export const BUTTON_HOVER_DARK_SOLID = '#F5F5F5';
export const BUTTON_HOVER_LIGHT_TRANSPARENT = 'rgba(0, 0, 0, 0.02)';
export const BUTTON_HOVER_DARK_TRANSPARENT = 'rgba(255, 255, 255, 0.05)';
export const BUTTON_ACTIVE_LIGHT_SOLID = '#3A3A3A';
export const BUTTON_ACTIVE_DARK_SOLID = '#EEEEEE';
export const BUTTON_ACTIVE_LIGHT_TRANSPARENT = 'rgba(0, 0, 0, 0.04)';
export const BUTTON_ACTIVE_DARK_TRANSPARENT = 'rgba(255, 255, 255, 0.08)';
export const BUTTON_HOVER_BORDER_LIGHT = '#1A1A1A';
export const BUTTON_HOVER_BORDER_DARK = '#FFFFFF';
export const BUTTON_ACTIVE_BORDER_LIGHT = '#2A2A2A';
export const BUTTON_ACTIVE_BORDER_DARK = '#FFFFFF';
//# sourceMappingURL=colors.js.map